<template>
  <v-card color="white">
    <v-card-text>
      <v-tabs v-model="tabLogin" align-tabs="center" color="deep-purple-accent-4">
        <v-tab value="option-1">{{t('imOptician')}}</v-tab>
        <v-tab value="option-2">{{t('imUser')}}</v-tab>
      </v-tabs>
      <v-tabs-window v-model="tabLogin">
        <!-- OPTICO -->
        <v-tabs-window-item value="option-1">
          <v-container fluid>
            <div class="text-subtitle-1 text-medium-emphasis">{{t('user')}}</div>
            <v-text-field
              ref="txtUser"
              v-model="usuario"
              :rules="[required]"
              @keypress.enter="$refs.txtPwd.focus()"
              rounded="lg"
              variant="solo"
              bg-color="#f4f4f4" />
            <!-- prepend-inner-icon="mdi-account" -->
            <div class="text-subtitle-1 text-medium-emphasis">{{t('password')}}</div>
            <v-text-field
              ref="txtPwd"
              :append-inner-icon="!showPwd ? 'mdi-eye' : 'mdi-eye-off'"
              v-model="password"
              @click:append-inner="showPwd = !showPwd"
              :type="showPwd ? 'text' : 'password'"
              :rules="[required]"
              @keypress.enter="sendLoginOptic"
              :error-messages="loginError && password == '' ? t('failedLogin') : ''"
              rounded="lg"
              variant="solo"
              bg-color="#f4f4f4" />
          </v-container>
        </v-tabs-window-item>

        <!-- CLIENTE -->
        <v-tabs-window-item value="option-2">
          <v-container fluid>
            <div class="text-subtitle-1 text-medium-emphasis">ID</div>
            <v-text-field ref="txtOT" v-model="ot" @keypress.enter="$refs.txtPwd.focus()" rounded="lg" variant="solo" bg-color="#f4f4f4" />
            <div class="text-subtitle-1 text-medium-emphasis">{{t('code')}}</div>
            <v-text-field ref="txtCodigo" v-model="codigo" @keypress.enter="sendLoginUser" rounded="lg" variant="solo" bg-color="#f4f4f4" />
          </v-container>
        </v-tabs-window-item>
      </v-tabs-window>
    </v-card-text>
    <v-card-actions class="justify-center">
      <v-btn class="flex-grow-1 mx-8 mt-n10" color="info" @click="tabLogin === 'option-1' ? sendLoginOptic() : sendLoginUser()" variant="elevated">
        <span class="fMontserrat" color="white"> {{t('send')}} </span>
      </v-btn>
    </v-card-actions>
  </v-card>
  <v-overlay :model-value="overlay" class="align-center justify-center">
    <v-progress-circular color="primary" size="64" indeterminate />
  </v-overlay>
  <MsgBoxComponent ref="msgBox" />
</template>

<script setup>
import axios from "axios";
import store from "./../store/index.js";
import { ref, defineEmits } from "vue"; //, watch
import MsgBoxComponent from "../components/MsgBoxComponent.vue";
import { t } from "../functions/translation.js";

const msgBox = ref(null);

const emit = defineEmits("closeloginform");

const ot = ref("");
const codigo = ref("");
const showPwd = ref(false);
const tabLogin = ref("option-1");
const usuario = ref("");
const password = ref("");
const loginError = ref(false);
const required = function (v) {
  return !!v || "Field is required";
};

var overlay = ref(false);

const sendLoginOptic = function () {
  overlay.value = true;
  var xmls = `<soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/" xmlns="http://indo.es/WSIndonetSOAP">
    <soap:Body>
        <wcfAutenticacion__Execute>
            <sClienteSAP>${usuario.value}</sClienteSAP>
            <sPasswordSAP>${password.value}</sPasswordSAP>
        </wcfAutenticacion__Execute>
    </soap:Body>
</soap:Envelope>`;

  axios
    .post(process.env.VUE_APP_INDONET_WS, xmls, {
      timeout: 45000,
      headers: { "Content-Type": "text/xml; charset=utf-8" },
    })
    .then((res) => {
      var codigo = new DOMParser();
      var oDOM = codigo.parseFromString(res.data, "text/xml");
      if (oDOM.getElementsByTagName("wcfAutenticacion__ExecuteResult").length > 0) {
        var result = JSON.parse(oDOM.getElementsByTagName("wcfAutenticacion__ExecuteResult")[0].textContent);

        if (result.CodigoRetorno === 0) {
          loginError.value = false;
          store.state.logged = true;
          store.state.optico = usuario.value;
          emit("closeloginform", "optico");
        } else {
          loginError.value = true;
          password.value = "";
          msgBox.value
            .alert({
              title: t('failedLogin'),
              message: result.MensajeErrorSAP,
              icon: "mdi-close-circle-outline",
              color: "red",
              btnOKColor: "red",
            })
        }
      }
    })
    .catch((err) => {
      console.error(err);
    })
    .finally(() => {
      overlay.value = false;
    });
};

const sendLoginUser = function () {
  overlay.value = true;

  var dto = { OT: ot.value, Codigo: codigo.value };

  axios
    .post(process.env.VUE_APP_INDO_WS + "/LoginUser", dto)
    .then((res) => {
      if (res.data !== "") emit("closeloginform", "usuario", res.data);
    })
    .catch((err) => {
      console.error(err);
    })
    .finally(() => {
      overlay.value = false;
    });
};
</script>

<style>
.fMontserrat {
  font-family: Montserrat;
}
</style>
